import type { ReactNode } from "react";
import { createPortal } from "react-dom";

interface RenderInSlotProps {
  /** The element to render into, as a `useState` ref callback holds it; `null` renders nothing. */
  slot: HTMLElement | null;
  children: ReactNode;
}

/**
 * Renders a component's part in a place its parent set aside higher up, while the
 * component keeps its state: a sidebar's top buttons that belong to one of its sections.
 */
export default function RenderInSlot({ slot, children }: RenderInSlotProps) {
  return slot === null ? null : createPortal(children, slot);
}
